<template>
  <div class="section-faq">
    <div class="container-1000">
      <div class="section-tag-container">
        <div class="section-tag">
          Schuette.shop FAQ
        </div>
      </div>
      <h2 class="text-center">
        Häufig gestellte Schuette® Shop Fragen & Antworten
      </h2>
      <div class="category-faq-container">
        <category-faq collapsable>
          <template #question>
            Für was steht Schuette®?
          </template>
          <template #answer>
            <p>Die Schuette® Familienmanufaktur steht für mehr als Sonnenschutz, Sichtschutz und Wohnaccessoires, denn Schuette® hat es sich zur Hauptaufgabe gemacht, Ihren <b> Wohnkomfort zu erhöhen und Ihre Lebensqualität zu steigern.</b> Mit Schuette® Produkten erhalten Sie daher weitaus mehr als Inneneinrichtung oder Deko für Ihr Zuhause: einfach ausprobieren und Unterschied spüren. ♥︎</p>
          </template>
        </category-faq>
        <category-faq collapsable>
          <template #question>
            Kann ich mich beraten lassen, wenn ich mir bei der Wahl der Fensterabdeckung unsicher bin?
          </template>
          <template #answer>
            <p>Natürlich, unser Expertenteam steht Ihnen <b>jederzeit mit Rat und Tat zur Seite</b> und hilft bei der Auswahl zwischen Plissee, Wabenplissee, Rollo oder Vorhang als Sicht- und Sonnenschutz. Schreiben Sie uns eine Nachricht, in der Sie uns:</p>
            <div class="check-list-container">
              <ol class="check-list">
                <li>Bilder Ihrer Fenster zusenden,</li>
                <li>mitteilen, ob Sie Bohren dürfen,</li>
                <li>und welcher Fensterschutz für Sie Priorität hat: lichtdurchlässig, leicht verdunkelnd, vollständig verdunkelnd, gegen Hitze- und Kälte usw. </li>
              </ol>
            </div>
            <p>Wir freuen uns, jederzeit auf Ihre Nachricht per Mail unter <b>emailfuerdich@schuette.shop oder über unser Nachrichtensystem</b>  auf der Homepage.</p>
          </template>
        </category-faq>
        <!-- <category-faq collapsable>
          <template #question>
            Wie kann ich den Kundenservice kontaktieren?
          </template>
          <template #answer>
            Unser Kundenservice kann per Mail unter emailfuerdich@schuette.shop oder über unser Nachrichtensystem auf der Homepage kontaktiert werden.
          </template>
        </category-faq> -->
        <category-faq collapsable>
          <template #question>
            Sind alle Schuette® Produkte blickdicht?
          </template>
          <template #answer>
            <p>Die meisten. Egal ob die Wahl auf ein Plissee, ein Rollo oder einen Vorhang fällt: <b>die blickdichten Schuette® Produkte halten Blicke ab</b>, und einige Stoffe lassen kein Sonnenlicht durch und dunkeln Räume stark ab.</p>
            <p>Blickdichte Schuette® Produkte sind beide Schuette® Vorhang Kollektionen, die Thermo Blackout Rollo Kollektion sowie fünf von sechs Schuette® Plissee Kollektionen. Halbtransparent ist die Melange Plissee Kollektion und das Tag & Nacht Doppelrollo hat abwechselnd blickdichte und transparente Streifen.</p>
          </template>
        </category-faq>
        <!-- <category-faq collapsable>
          <template #question>
            Welchen Stoff sollte ich wählen?
          </template>
          <template #answer>
            Die Auswahl des richtigen Stoffes kann in Hinblick auf Farbe, Design sowie die Eigenschaften des Stoffes getroffen werden. Jede Stoffart und jedes Design hat ihre eigenen Vorteile. Die Stoffeigenschaften variieren manchmal auch je nach Farbwahl. Näheres zu den jeweiligen Stoffeigenschaften finden Sie auf unserer Produktseite.
          </template>
        </category-faq> -->
        <!-- <category-faq collapsable>
          <template #question>
            Was ist die silberne Beschichtung bei Thermo Produkten?
          </template>
          <template #answer>
            Die Beschichtung auf der Rückseite (Fensterseite) unserer Thermo-Stoffe reflektiert die Sonnenstrahlen und verlangsamt unter anderem deutlich das Eindringen von Hitze. Eine zusätzliche Eigenschaft der glänzenden Beschichtung ist eine mittlere bis hohe Verdunkelung des Raums. Bei dunklen Stofffarben ist die Eigenfarbe der Hitzeschutzausrüstung auf der Stoffrückseite silbern, aber bei hellen Farben eher ein Beigeton.
          </template>
        </category-faq> -->
        <!-- <category-faq collapsable>
          <template #question>
            Kann ich Stoffmuster bestellen?
          </template>
          <template #answer>
            Sehr gerne. Stoffmuster können über unseren Kundenservice bestellt werden.
          </template>
        </category-faq> -->
        <!-- <category-faq collapsable>
          <template #question>
            Kann ich auch nur Stoffe oder Profile bestellen?
          </template>
          <template #answer>
            Das kommt darauf an. Es ist möglich, Muster von Stoffen sowie zusätzliche Dachfenster-Führungsprofile nachzubestellen. Bei Bedarf kann hierfür unser Kundenservice kontaktiert werden. Zudem können jederzeit Plissee- und Rollo-Halterungen über unsere Homepage als Zubehör nachbestellt werden. Ganze Stoffbahnen, Profilschienen sowie Vorhang-Ösen können nicht separat bestellt werden.
          </template>
        </category-faq> -->
        <category-faq collapsable>
          <template #question>
            Was sind die Rückgabe&shy;bedingungen?
          </template>
          <template #answer>
            <p><b>Die Rückgabebedingungen variieren je nach Produktart:</b> alle Produkte nach Maß, d.h. Maßanfertigungen, sind von einer Rückgabe und einem Tausch ausgeschlossen, da diese individuell und speziell für jeden Kunden direkt nach aufgegebener Bestellung angefertigt werden. Bereits vorgefertigte Produkte, wie Bettlaken und Kissenbezüge, können innerhalb der Rückgabefrist zurückgegeben werden, sofern sie sich in einem einwandfreien, neuen Zustand befinden. Die jeweilige Produktart ist im Titel der Produkte beschrieben. Genaueres zu unseren Rückgabebedingungen finden Sie in unseren AGBs sowie in der Widerrufsbelehrung.</p>
          </template>
        </category-faq>
        <category-faq collapsable>
          <template #question>
            Gibt es eine Möglichkeit Schuette® Produkte vor dem Kauf stationär anzusehen?
          </template>
          <template #answer>
            <p>Schuette® Ausstellungsräume und stationäre Shops mit unseren Schuette® Markenprodukten befinden sich momentan <b>noch in der Planungsphase. Umso realitätsgetreuer sind daher unsere Produktbilder:</b> jedes Produkt entspricht bis auf das kleinste Detail dem präsentieren Produktbild auf der Schuette® Homepage. Für ein Haptikerlebnis vor finaler Bestellung können bei Bedarf Stoff- und Haltermuster über unseren Kundenservice bestellt werden.</p>
          </template>
        </category-faq>
        <category-faq collapsable>
          <template #question>
            Wann beginnt die Anfertigung meiner Schuette® Bestellung?
          </template>
          <template #answer>
            <p>Für einen schnellstmöglichen Versand aller Produkte, inbegriffen maßgefertigter Produkte, beginnt die Anfertigung aller Schuette® Produkte <b> direkt nach aufgegebener Bestellung.</b> Mit einigen Vorbereitungs- und Bearbeitungsschritten beginnen wir sogar automatisch und unmittelbar nach dem Bestelleingang. Wir können daher stolz sagen, dass der Großteil aller Bestellungen noch vor dem angezeigten Liefertermin zugestellt werden kann.</p>
          </template>
        </category-faq>
        <!-- <category-faq collapsable>
          <template #question>
            Werden für die Montage von Schuette® Produkten irgendwelche Werkzeuge benötigt?
          </template>
          <template #answer>
            Dies kommt auf die ausgewählte Befestigungsart an. Für eine Montage ohne Bohren werden keine Werkzeuge benötigt. Sofern Sie sich für eine Montage mit Bohren von Plissees oder Rollos entscheiden, reicht je nach Fenstertyp sogar ein Schraubenzieher aus. Wenn Sie für die Montage von Plissees “mit Bohren” zusätzlich einen Akkuschrauber und kleine Bohrer (⌀ 1.0 -2.0 mm) parat haben, wird es nochmal schneller und einfacher gehen.
          </template>
        </category-faq> -->
        <category-faq collapsable>
          <template #question>
            Wie viel Zeit benötige ich für die Montage?
          </template>
          <template #answer>
            <p>Die Montagezeit variiert nach Produktart und Befestigungsmethode, dauert <b> durchschnittlich ganz alleine nur wenige Minuten</b> und verkürzt sich mit jedem weiteren installierten Produkt.</p>
            <p>Ein Montageservice oder andere <b>professionelle Hilfe ist überflüssig,</b> denn alle Schuette® Produkte sind bei Messung nach vorgegebener Anleitung möglichst vollständig vorbereitet ohne Nachjustierungsbedarf.</p>
            <p>Es war für uns in der Schuette® Manufaktur außerordentlich wichtig, die Montage von jedem Produkt in jeder Montageart so einfach und schnell wie möglich für Sie zu gestalten. Dank unserer Vormontage ist die Montagezeit deutlich kürzer als bei anderen Herstellern, ohne Baukasten und Puzzlearbeit.</p>
          </template>
        </category-faq>
        <!-- <category-faq collapsable>
          <template #question>
            Wo finde ich die Montageanleitung?
          </template>
          <template #answer>
            Die Montageanleitung wird zu jedem Produkt beigelegt. Diese finden Sie in der Verpackung bei den Griffen und Halterungen. Sollten Sie eine zusätzliche Kopie benötigen, kontaktieren Sie bitte unseren Kundenservice. Dieser sendet Ihnen gerne eine PDF-Datei per Mail zu.
          </template>
        </category-faq> -->
        <category-faq collapsable>
          <template #question>
            Muss ich Halterungen oder anderes Zubehör einzeln kaufen?
          </template>
          <template #answer>
            <p><b> Alle benötigten Zubehörteile sind bei Schuette® Produkten bereits enthalten:</b> hierzu zählen beispielsweise Plissee und Rollo Befestigungen, Reinigungstuch und Klebestreifen für Klebeplissees, Drehschlüssel für Klemmplissees oder Schrauben für Bohrplissees und Rollos. Für Vorhänge mit Tunnelband müssen die Haken oder Gleiter separat, beispielsweise im Baumarkt, erworben werden. Bei Ösenvorhängen sind die Ösen bereits enthalten.</p>
          </template>
        </category-faq>
        <!-- <category-faq collapsable>
          <template #question>
            Bietet Schuette® ebenfalls einen Montageservice an?
          </template>
          <template #answer>
            Ein Montageservice ist nicht nötig, da die Montage von unseren Produkten kinderleicht ist und hierfür keinerlei professionelle Hilfe benötigt wird. Alle Produkte sind, sofern nach Messanleitung gemessen wurde, bereits so von uns vorbereitet, dass nichts nachjustiert werden muss und lediglich die Halterungen und Griffe angebracht werden müssen. Hierfür wird keine professionelle Hilfe von einem Montageteam benötigt, was zusätzlich deutlich Kosten spart!
          </template>
        </category-faq> -->
        <!-- <category-faq collapsable>
          <template #question>
            Hat Schuette® einen Reparaturservice?
          </template>
          <template #answer>
            Ja. Für den Fall, dass Plissees oder Rollos angepasst oder eingekürzt werden müssen oder bei der Montage etwas schief gegangen ist, haben wir einen Reparaturservice eingerichtet. Bitte kontaktieren Sie dafür unseren Kundensupport per Mail oder Chat.
          </template>
        </category-faq> -->
        <!-- <category-faq collapsable>
          <template #question>
            Was kann ich tun, wenn ich mich vermessen habe?
          </template>
          <template #answer>
            Je nachdem, inwiefern Sie sich vermessen haben, ist dies nicht weiter schlimm. Bei Plissees reicht es sogar manchmal aus, lediglich die Halterungen gegen andere zu tauschen. Reicht das nicht aus, dann haben wir ja noch unseren Reparaturservice im Zuge dessen wir kleinere Maßänderungen vornehmen können. Haben Sie sich vermessen? Dann kontaktieren Sie bitte unseren Kundenservice und geben Ihre Bestellnummer und die betroffenen Produkte zusammen mit den neuen Wunschmaßen durch.
          </template>
        </category-faq> -->
        <category-faq collapsable>
          <template #question>
            Wie lange ist die Lieferzeit und was kostet der Versand?
          </template>
          <template #answer>
            <p>Die Lieferzeit für das jeweilige Produkt wird auf der Produktseite sowie im Warenkorb angezeigt und liegt durchschnittlich bei <b>7-10 Tagen</b>, mit <b>kostenlosem Versand innerhalb Deutschlands sowie nach Österreich.</b>  Sprechen Sie uns bei speziellen Wünschen zur Lieferzeit gerne an. Die Versandkosten für andere Lieferländer werden im Warenkorb angezeigt, sobald das Lieferland ausgewählt wurde.</p>
            <p>Der <b>Sendungsstatus Ihrer Bestellung</b>  ist über die per E-Mail erhaltene Sendungsverfolgung einsehbar. Den Link zur Sendungsverfolgung erhalten Sie, sobald Ihre Bestellung für den Versand vorbereitet wird. Der Sendungsstatus benötigt je nach Lieferunternehmen einige Stunden, bis dieser in der Sendungsverfolgung nach Abholung des Pakets einsehbar ist.</p>
          </template>
        </category-faq>
        <!-- <category-faq collapsable>
          <template #question>
            Wie viel kostet der Versand?
          </template>
          <template #answer>
            Der Versand ist innerhalb Deutschlands sowie nach Österreich kostenfrei. Die Versandkosten für andere Lieferländer werden im Warenkorb angezeigt, sobald das Lieferland ausgewählt wurde.
          </template>
        </category-faq> -->
        <!-- <category-faq collapsable>
          <template #question>
            Wie kann ich den Sendungsstatus meiner Bestellung prüfen?
          </template>
          <template #answer>
            An die in der Bestellung genannte Mailadresse schicken wir innerhalb weniger Tage nach Ihrer Bestellung eine Mail mit der Sendungsnummer, dem dazugehörigen Lieferunternehmen sowie dem Link zur Sendungsverfolgung. Anhand dieser Informationen kann der Sendungsstatus jederzeit geprüft werden.
          </template>
        </category-faq> -->
        <category-faq collapsable>
          <template #question>
            Welche Zahlungsmethoden stehen mir zur Verfügung?
          </template>
          <template #answer>
            <p>
              Alle verfügbaren Zahlungsmethoden werden <b> im Warenkorb angezeigt:</b>
            </p>
            <div class="check-list-container">
              <ul class="check-list is-fullwidth">
                <li><b>PayPal</b></li>
                <li><b>Apple Pay</b></li>
                <li><b>Google Pay</b></li>
                <li><b>Kreditkarte</b></li>
                <li><b>Klarna Pay Later Kauf auf Rechnung</b></li>
                <li><b>Klarna Slice It Ratenkauf</b></li>
                <li><b>Vorkasse/Banküberweisung</b></li>
                <li><b>Sofort-Überweisung</b></li>
              </ul>
            </div>
            <p>Die Proforma-Rechnung erhalten Sie per Mail als Anhang zur Bestellbestätigung. Die finale Rechnung wird nach Eingang der Zahlung in der Zahlungsbestätigung versendet. Sollten Sie keine Rechnung erhalten haben, kontaktieren Sie bitte unseren Kundenservice.</p>
          </template>
        </category-faq>
        <category-faq collapsable>
          <template #question>
            Wann und wie erhalte ich meine Rechnung?
          </template>
          <template #answer>
            <p>Die Proforma-Rechnung erhalten Sie per Mail als Anhang zur Bestellbestätigung. Die finale Rechnung wird nach Eingang der Zahlung in der Zahlungsbestätigung versendet. Sollten Sie keine Rechnung erhalten haben, kontaktieren Sie bitte unseren Kundenservice.</p>
          </template>
        </category-faq>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryFaq from '~/components/shared/CategoryFaq'

export default {
  components: {
    CategoryFaq
  },
  props: {
    categories: {
      type: Array,
      default: null
    }
  }
}
</script>
